import {
  INSURANCE_DETAIL_UPDATE_LIST_CLEAR_FILTERS,
  INSURANCE_DETAIL_UPDATE_LIST_ERROR,
  INSURANCE_DETAIL_UPDATE_LIST_RECEIVED,
  INSURANCE_DETAIL_UPDATE_LIST_REQUEST,
  INSURANCE_DETAIL_UPDATE_LIST_SET_FILTERS,
  INSURANCE_DETAIL_UPDATE_LIST_SET_PAGE,
  INSURANCE_DETAIL_UPDATE_LIST_UNLOAD,
  INSURANCE_DETAIL_UPDATE_LIST_UNLOAD_PERSIST_FILTERS,
  INSURANCE_DETAILS_REQUEST,
  INSURANCE_DETAILS_UPDATED,
} from '../constants';
import { requests } from '../../helper/agent';
import * as API_ROUTES from '../../routing/api';
import { SubmissionError } from 'redux-form';
import { parseApiErrors } from '../../helper/apiUtils';
import { userLogout } from './user';

export const insuranceDetailsRequest = () => ({
  type: INSURANCE_DETAILS_REQUEST,
});

export const insuranceDetailsUpdated = (data) => ({
  type: INSURANCE_DETAILS_UPDATED,
  data,
});

export const addInsurerDetails = (formValues) => {
  return (dispatch) => {
    dispatch(insuranceDetailsRequest());
    return requests
      .post(API_ROUTES.ADD_INSURANCE_DETAILS, formValues)
      .then((response) => dispatch(insuranceDetailsUpdated(response)))
      .catch((error) => {
        if (error && error.response && error.response.status === 401) {
        }
        throw new SubmissionError(parseApiErrors(error));
      });
  };
};

export const invoiceInsuranceDetailsActioned = (id) => {
  return (dispatch) => {
    dispatch(insuranceDetailsRequest());
    return (
      requests
        .post(API_ROUTES.ACTION_INSURANCE_DETAILS.replace(':id', id), {})
        //        .then(response => dispatch(insuranceDetailsUpdated(response)))
        .catch((error) => {
          if (error && error.response && error.response.status === 401) {
          }
          throw new SubmissionError(parseApiErrors(error));
        })
    );
  };
};

export const insuranceDetailUpdateListRequest = () => ({
  type: INSURANCE_DETAIL_UPDATE_LIST_REQUEST,
});

export const insuranceDetailUpdateListReceived = (data) => ({
  type: INSURANCE_DETAIL_UPDATE_LIST_RECEIVED,
  data,
});

export const insuranceDetailUpdateListError = (error) => ({
  type: INSURANCE_DETAIL_UPDATE_LIST_ERROR,
  error,
});

export const insuranceDetailUpdateListSetPage = (page) => ({
  type: INSURANCE_DETAIL_UPDATE_LIST_SET_PAGE,
  page,
});

export const insuranceDetailUpdateListSetFilters = (filters, routeKey) => ({
  type: INSURANCE_DETAIL_UPDATE_LIST_SET_FILTERS,
  filters,
  routeKey,
});

export const insuranceDetailUpdateListClearFilters = (routeKey) => ({
  type: INSURANCE_DETAIL_UPDATE_LIST_CLEAR_FILTERS,
  routeKey,
});

export const insuranceDetailUpdateListUnload = (persistFilters = true, routeKey) => {
  if (persistFilters) {
    return {
      type: INSURANCE_DETAIL_UPDATE_LIST_UNLOAD_PERSIST_FILTERS,
      routeKey,
    };
  }
  return {
    type: INSURANCE_DETAIL_UPDATE_LIST_UNLOAD,
    routeKey,
  };
};

export const insuranceDetailUpdateListFetch = (page = 1, filters = {}) => {
  return (dispatch) => {
    dispatch(insuranceDetailUpdateListRequest());
    if (filters.pagination === undefined) {
      filters.pagination = true;
    }
    if (filters.pagination) {
      filters.page = page;
    }
    return requests
      .get(API_ROUTES.ADD_INSURANCE_DETAILS, filters)
      .then((response) => dispatch(insuranceDetailUpdateListReceived(response)))
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        } else if (error.response && error.response.status === 403) {
          return new SubmissionError(parseApiErrors({ _error: 'You are not allowed to do this.' }));
        }
        dispatch(insuranceDetailUpdateListError(error));
      });
  };
};
